import { jsx } from 'react/jsx-runtime';
import { cn } from '../../../lib/utils.js';

const GradientInfoBox = ({ children, className }) => {
  return /* @__PURE__ */ jsx("div", { className: cn("gradient-round-box", className), children });
};

export { GradientInfoBox };
